namespace RioERP.Orders {
    export interface ScanBookRequest1 extends Serenity.ServiceRequest {
        BookIsbn?: string;
        OrderId?: number;
    }
}
